export enum ApplicantsSortByEnum {
    NEWEST_FIRST = 'NEWEST_FIRST',
    BEST_MATCHED = 'BEST_MATCHED',
}
